import React from "react";
import Image from "next/image";
import Link from "next/link";

import { FiArrowRight } from "react-icons/fi";
import { FaArrowRight, FaGithub } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";
import website_logo from "../../../../public/assets/General-Img/About/core-team/website_logo.webp";
import wrapcast_logo from "../../../../public/assets/General-Img/About/core-team/wrapcast_logo.webp";
import Anandi_Sheladiya from "../../../../public/assets/blog/Main Blog/Anandi_Sheladiya.webp";
import Mohit_Kapadiya from "../../../../public/assets/blog/Main Blog/Mohit_Kapadiya.webp";
import Youtube_colored from "../../../../public/assets/blog/Main Blog/Youtube_colored.webp";
import Instargram_colored from "../../../../public/assets/blog/Main Blog/Instargram_colored.webp";
import FaceBook_colored from "../../../../public/assets/blog/Main Blog/FaceBook_colored.webp";
import Tiktok_colored from "../../../../public/assets/blog/Main Blog/Tiktok_colored.webp";
import { FaArrowRightLong, FaXTwitter } from "react-icons/fa6";

const AuthorInfor = ({ content }) => {
    return (
        <div className="flex sm:flex-nowrap flex-wrap w-full !mt-10">
            <div className="flex gap-x-2 flex-wrap sm:justify-start justify-center sm:mx-0 mx-auto items-center sm:min-w-[240px]">
                <div className="min-w-[60px] min-h-[60px] relative">
                    {content?.data[0]?.attributes?.seo?.metaArticle?.authors[0]
                        ?.firstName === "Anandi" ? (
                        <Image
                            fill
                            src={Anandi_Sheladiya}
                            alt={
                                content?.data[0]?.attributes?.seo?.metaArticle
                                    ?.authors[0]?.image?.data?.attributes
                                    ?.alternativeText
                            }
                            className="rounded-full"
                        />
                    ) : (
                        <Image
                            fill
                            src={Mohit_Kapadiya}
                            alt={
                                content?.data[0]?.attributes?.seo?.metaArticle
                                    ?.authors[0]?.image?.data?.attributes
                                    ?.alternativeText
                            }
                            className="rounded-full"
                        />
                    )}
                </div>

                <div className="gradientBorderShow pr-7">
                    <div className="flex gap-4 my-1">
                        <div className="flex flex-col gap-0.5">
                            <span className="text-black font-bold text-sm font-manrope capitalize">
                                {
                                    content?.data[0]?.attributes?.seo
                                        ?.metaArticle?.authors[0]?.firstName
                                }{" "}
                                {
                                    content?.data[0]?.attributes?.seo
                                        ?.metaArticle?.authors[0]?.lastName
                                }
                            </span>
                            <span className="text-[#686868] text-xs">
                                {
                                    content?.data[0]?.attributes?.seo
                                        ?.metaArticle?.authors[0]?.designation
                                }
                            </span>
                        </div>
                        <Link
                            target="_blank"
                            aria-label="FaArrowRightLong"
                            href={`/author/${content?.data[0]?.attributes?.seo?.metaArticle?.authors[0]?.username}`}
                            className="text-[#410ead] block text-xl"
                        >
                            <FaArrowRightLong />
                        </Link>
                    </div>

                    <div className="flex items-center justify-start gap-2 md:justify-start my-1">
                        {content?.data[0]?.attributes?.seo?.metaArticle
                            ?.authors[0]?.firstName === "Anandi" ? (
                            <div className="flex gap-2">
                                {/* Personal website */}
                                <Link
                                    href="https://www.anandisheladiya.com"
                                    target="_blank"
                                >
                                    <Image
                                        src={website_logo}
                                        alt="website_logo"
                                        className="w-4 h-4"
                                        title="Website"
                                    />
                                </Link>

                                {/* github */}
                                <Link
                                    href="https://github.com/CodebyAnandi"
                                    target="_blank"
                                    title="Github"
                                >
                                    <FaGithub className="text-base" />
                                </Link>

                                {/* linkedin */}
                                <Link
                                    href="https://www.linkedin.com/in/anandi-sheladiya-200893101"
                                    target="_blank"
                                    title="Linkedin"
                                >
                                    <FaLinkedinIn className="text-base text-[#0077b5]" />
                                </Link>

                                {/* twitter */}
                                <Link
                                    href="https://x.com/Anandi_007"
                                    target="_blank"
                                    title="X"
                                >
                                    <FaXTwitter className="text-base" />
                                </Link>

                                {/* wrapcast */}
                                <Link
                                    href="https://warpcast.com/anandi"
                                    target="_blank"
                                    title="Warpcast"
                                >
                                    <Image
                                        src={wrapcast_logo}
                                        alt="wrapcast_logo"
                                        className="w-4 h-4"
                                    />
                                </Link>

                                {/* youtube */}
                                <a
                                    href="https://www.youtube.com/@AnandiOnchain"
                                    target="_blank"
                                >
                                    <Image
                                        src={Youtube_colored}
                                        alt="Youtube_colored"
                                        className="cursor-pointer"
                                    />
                                </a>

                                {/* instargram */}
                                <a
                                    href="https://www.instagram.com/anandi.onchain/?igsh=emJpOTg5bG9xOG9l&utm_source=qr#"
                                    target="_blank"
                                >
                                    <Image
                                        src={Instargram_colored}
                                        alt="Instargram_colored"
                                        className="cursor-pointer"
                                    />
                                </a>

                                {/* facebook */}
                                <a
                                    href="https://www.facebook.com/people/Anandi-Onchain/pfbid0VZ6Pm1AFGRacU6m2PW9axisJ6QkcZdd4XuZssJodePEM2novEK4nastrpqScXkuXl/?mibextid=wwXIfr&rdid=huMuhUIJCGCBZFYM&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F163jHazm1c%2F%3Fmibextid%3DwwXIfr"
                                    target="_blank"
                                >
                                    <Image
                                        src={FaceBook_colored}
                                        alt="FaceBook_colored"
                                        className="cursor-pointer"
                                    />
                                </a>
                            </div>
                        ) : (
                            <div className="flex gap-2">
                                {/* Personal website */}
                                <Link
                                    href="https://www.mohitkapadiya.com"
                                    target="_blank"
                                >
                                    <Image
                                        src={website_logo}
                                        alt="website_logo"
                                        className="w-4 h-4"
                                        title="Website"
                                    />
                                </Link>

                                {/* github */}
                                <Link
                                    href="https://github.com/codebyMoh"
                                    target="_blank"
                                    title="Github"
                                >
                                    <FaGithub className="text-base" />
                                </Link>

                                {/* linkedin */}
                                <Link
                                    href="https://www.linkedin.com/in/mohit-kapadiya"
                                    target="_blank"
                                    title="Linkedin"
                                >
                                    <FaLinkedinIn className="text-base text-[#0077b5]" />
                                </Link>

                                {/* twitter */}
                                <Link
                                    href="https://x.com/Mohtajj95"
                                    target="_blank"
                                    title="X"
                                >
                                    <FaXTwitter className="text-base" />
                                </Link>

                                {/* wrapcast */}
                                <Link
                                    href="https://warpcast.com/mohitkapadiya"
                                    target="_blank"
                                    title="Warpcast"
                                >
                                    <Image
                                        src={wrapcast_logo}
                                        alt="wrapcast_logo"
                                        className="w-4 h-4"
                                    />
                                </Link>

                                {/* youtube */}
                                <Link
                                    href="https://www.youtube.com/@mohitkapadiyaa"
                                    target="_blank"
                                    title="Youtube"
                                >
                                    <Image
                                        src={Youtube_colored}
                                        alt="Youtube_colored"
                                        className="w-4 h-4"
                                    />
                                </Link>

                                {/* instargram */}
                                <Link
                                    href="https://www.instagram.com/mohitkapadiya.eth"
                                    target="_blank"
                                    title="Instargram"
                                >
                                    <Image
                                        src={Instargram_colored}
                                        alt="Instargram_colored"
                                        className="w-4 h-4"
                                    />
                                </Link>

                                {/* tiktok */}
                                <Link
                                    href="https://www.tiktok.com/@mohitkapadiyaa"
                                    target="_blank"
                                    title="Tiktok"
                                >
                                    <Image
                                        src={Tiktok_colored}
                                        alt="Tiktok_colored"
                                        className="w-4 h-4"
                                    />
                                </Link>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div className="w-full sm:text-left text-center sm:mt-0 mt-4 md:-mb-10 flex flex-col justify-center">
                <p className="mt-1 text-sm">
                    {content?.data[0]?.attributes?.seo?.metaArticle?.authors[0]
                        ?.firstName === "Anandi"
                        ? "Anandi S is dedicated to crafting groundbreaking products that are transforming the Web3,Blockchain and NFT landscape."
                        : "Mohit as long-time builder in the Web3 space since 2015, Mohit previously developed fastest on-chain social trading systems on Solana and contributed to Ethereum and open-source blockchain communities. He is the Founder and CTO of Tanthetaa, one of India’s earliest blockchain service studios, leading 250 + Engineering team and serves on the advisory board of several tech startups."}
                </p>
            </div>
        </div>
    );
};

export default AuthorInfor;
